<template>
  <div>
    <div class="header-row">
      <div class="left-tools">
        <el-button size="mini" icon="el-icon-back" @click="goBack">返回列表</el-button>
        <span class="scene-text">关联场景：{{ sceneLabel }}</span>
      </div>
      <el-button type="success" size="mini" :loading="exportLoading" @click="exportData">导出</el-button>
    </div>

    <el-card shadow="never" class="filter-card">
      <el-form :inline="true" label-width="90px">
        <el-form-item label="经销商HQID">
          <el-input v-model="params.dealer_hq_id" clearable placeholder="请输入HQ ID" style="width: 170px;"></el-input>
        </el-form-item>
        <el-form-item label="经销商名称">
          <el-input v-model="params.dealer_name" clearable placeholder="请输入经销商名称" style="width: 170px;"></el-input>
        </el-form-item>
        <el-form-item label="Apple ID">
          <el-input v-model="params.shop_code" clearable placeholder="请输入Apple ID" style="width: 170px;"></el-input>
        </el-form-item>
        <el-form-item label="门店名称">
          <el-input v-model="params.distributor_name" clearable placeholder="请选择门店" style="width: 170px;"></el-input>
        </el-form-item>
        <el-form-item label="推送状态">
          <el-select v-model="params.push_status" clearable placeholder="请选择" style="width: 170px;">
            <el-option label="已推送" value="success"></el-option>
            <el-option label="推送失败" value="fail"></el-option>
            <el-option label="待推送" value="wait"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="反馈状态">
          <el-select v-model="params.feedback_status" clearable placeholder="请选择" style="width: 170px;">
            <el-option label="是" value="submitted"></el-option>
            <el-option label="否" value="unsubmitted"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="开始日期">
          <el-date-picker
            v-model="startDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            style="width: 170px;"
            :picker-options="pickerOptions"
            @change="onStartDateChange">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="结束日期">
          <el-date-picker
            v-model="endDate"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择日期"
            style="width: 170px;"
            :picker-options="pickerOptions"
            @change="onEndDateChange">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="searchData">查询</el-button>
        </el-form-item>
      </el-form>
      <div class="tips">
        查询一级：{{ currentQuerySummary }}
      </div>
    </el-card>

    <el-table v-loading="loading" :data="list" stripe border :height="wheight - 280">
      <el-table-column prop="dealer_hq_id" label="经销商HQID" min-width="120"></el-table-column>
      <el-table-column prop="dealer_name" label="经销商名称" min-width="150" show-overflow-tooltip></el-table-column>
      <el-table-column prop="channel_rtm" label="渠道RTM" min-width="100"></el-table-column>
      <el-table-column prop="shop_code" label="AppleID" min-width="120"></el-table-column>
      <el-table-column prop="distributor_name" label="门店名称" min-width="150" show-overflow-tooltip></el-table-column>
      <el-table-column prop="push_date" label="问卷推送日期" min-width="130"></el-table-column>
      <el-table-column prop="order_no" label="活动详情单号" min-width="180" show-overflow-tooltip></el-table-column>
      <el-table-column prop="is_subscribe" label="是否订阅消息" min-width="110">
        <template slot-scope="scope">
          {{ subscribeText(scope.row.is_subscribe) }}
        </template>
      </el-table-column>
      <el-table-column prop="push_status" label="推送状态" min-width="110">
        <template slot-scope="scope">
          {{ pushStatusText(scope.row.push_status) }}
        </template>
      </el-table-column>
      <el-table-column prop="feedback_status" label="反馈状态" min-width="110">
        <template slot-scope="scope">
          {{ feedbackStatusText(scope.row.feedback_status) }}
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      background
      layout="total, sizes, prev, pager, next, jumper"
      :current-page="params.page"
      :page-size="params.page_size"
      :page-sizes="[20, 50, 100]"
      :total="totalCount"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange">
    </el-pagination>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getQuestionnairePushStatisticsDetail } from '@/api/datacube'

export default {
  name: 'questionnairepushstatistics_detail',
  data () {
    return {
      loading: false,
      exportLoading: false,
      startDate: '',
      endDate: '',
      list: [],
      totalCount: 0,
      params: {
        page: 1,
        page_size: 20,
        push_date_start: '',
        push_date_end: '',
        scene_type: '',
        distributor_id: '',
        dealer_hq_id: '',
        dealer_name: '',
        shop_code: '',
        distributor_name: '',
        order_no: '',
        push_status: '',
        feedback_status: ''
      },
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now()
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ]),
    sceneLabel () {
      if (Number(this.params.scene_type) === 2) {
        return '售后维修'
      }
      if (Number(this.params.scene_type) === 1) {
        return '新机设置'
      }
      return '全部'
    },
    currentQuerySummary () {
      const arr = []
      if (this.params.dealer_name) arr.push(this.params.dealer_name)
      if (this.params.distributor_name) arr.push(this.params.distributor_name)
      if (this.params.scene_type) arr.push(this.sceneLabel)
      if (this.params.shop_code) arr.push(this.params.shop_code)
      return arr.length ? arr.join(' / ') : '无'
    }
  },
  methods: {
    sceneTypeText (sceneType) {
      return Number(sceneType) === 2 ? '售后维修' : '新机设置'
    },
    pushStatusText (status) {
      if (status === 'success') {
        return '已推送'
      }
      if (status === 'fail') {
        return '推送失败'
      }
      return '待推送'
    },
    feedbackStatusText (status) {
      return status === 'submitted' ? '是' : '否'
    },
    subscribeText (val) {
      return Number(val) === 1 ? '是' : '否'
    },
    onStartDateChange (val) {
      this.params.push_date_start = val || ''
    },
    onEndDateChange (val) {
      this.params.push_date_end = val || ''
    },
    searchData () {
      this.params.page = 1
      this.getList()
    },
    handleCurrentChange (page) {
      this.params.page = page
      this.getList()
    },
    handleSizeChange (pageSize) {
      this.params.page = 1
      this.params.page_size = pageSize
      this.getList()
    },
    getList () {
      this.loading = true
      getQuestionnairePushStatisticsDetail(this.params).then(res => {
        const data = (res.data && res.data.data) ? res.data.data : {}
        this.list = data.list || []
        this.totalCount = Number(data.total_count || 0)
      }).catch(() => {
        this.$message.error('获取问卷推送明细失败')
      }).finally(() => {
        this.loading = false
      })
    },
    exportData () {
      this.exportLoading = true
      const query = {
        ...this.params,
        export: 1
      }
      getQuestionnairePushStatisticsDetail(query).then(res => {
        if (res.data && res.data.data && res.data.data.status) {
          this.$message({
            type: 'success',
            message: '已加入执行队列，请在设置-导出列表中下载'
          })
          return
        }
        this.$message({
          type: 'error',
          message: '无内容可导出 或 执行失败，请检查重试'
        })
      }).catch(() => {
        this.$message.error('导出失败，请稍后重试')
      }).finally(() => {
        this.exportLoading = false
      })
    },
    goBack () {
      this.$router.back()
    },
    initFromQuery () {
      const query = this.$route.query || {}
      this.params.push_date_start = query.push_date_start || ''
      this.params.push_date_end = query.push_date_end || ''
      this.params.scene_type = query.scene_type ? Number(query.scene_type) : ''
      this.params.dealer_hq_id = query.dealer_hq_id || ''
      this.params.dealer_name = query.dealer_name || ''
      this.params.shop_code = query.shop_code || ''
      this.params.distributor_name = query.distributor_name || ''
      this.startDate = this.params.push_date_start || ''
      this.endDate = this.params.push_date_end || ''

    }
  },
  mounted () {
    this.initFromQuery()
    this.getList()
  }
}
</script>

<style scoped>
.header-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
}
.left-tools {
  display: flex;
  align-items: center;
  gap: 12px;
}
.scene-text {
  color: #666;
  font-size: 13px;
}
.filter-card {
  margin-bottom: 10px;
}
.tips {
  color: #909399;
  font-size: 12px;
}
</style>
